// Client-reported diagnostics; the backend determines the request IP independently.
export function browserSmsInfo () {
  const ua = navigator.userAgent || ''
  const info = { platform: 'web', device_name: /iPhone/.test(ua) ? 'iPhone' : /iPad/.test(ua) ? 'iPad' : /Android/.test(ua) ? 'Android 裝置' : '電腦' }
  let match
  if ((match = ua.match(/Android[ /]([0-9.]+)/))) { info.os_name = 'Android'; info.os_version = match[1] } else if ((match = ua.match(/(?:iPhone|CPU) OS ([0-9_]+)/))) { info.os_name = 'iOS'; info.os_version = match[1].replace(/_/g, '.') } else if ((match = ua.match(/Windows NT ([0-9.]+)/))) { info.os_name = 'Windows'; info.os_version = match[1] } else if ((match = ua.match(/Mac OS X ([0-9_]+)/))) { info.os_name = 'macOS'; info.os_version = match[1].replace(/_/g, '.') }
  for (const [token, name] of [['Edg', 'Edge'], ['Chrome', 'Chrome'], ['Firefox', 'Firefox'], ['Version', 'Safari']]) {
    match = ua.match(new RegExp(token + '/([0-9.]+)'))
    if (match) { info.browser = name + ' ' + match[1]; break }
  }
  return info
}
export function smsHeaders (info) {
  const headers = {}
  Object.keys(info).forEach(key => { if (info[key]) headers['X-Sms-' + key.replace(/_/g, '-')] = encodeURIComponent(String(info[key]).slice(0, 150)) })
  return headers
}
export function isOtpRequest (config) {
  return /(?:login|forgot-password|otp|send-otp|send-email)(?:[/?]|$)/i.test(String(config.url || '')) && String(config.method || 'get').toLowerCase() === 'post'
}
